import React from 'react';

import { getText } from './Text';
import tsAmplifyStyles from '../containers/SignIn/tsAmplifyStyles';

export default function GoogleSignInButton({ buttonClicked }) {
  return (
    <button
      title={getText('Sign In Google')}
      style={tsAmplifyStyles.socialSignInButton}
      type="button"
      onClick={buttonClicked}
      onKeyDown={buttonClicked}
    >
      <img
        alt={getText('Sign In Google')}
        src="/images/btn_google_signin_light_normal_web.png"
        srcSet="/images/btn_google_signin_light_normal_web.png 1x,
        /images/btn_google_signin_light_normal_web@2x.png 2x"
      />
    </button>
  );
}
